// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3-4iA","image":"styles_image__1rNL8"};